define('PartLookup.Base.View', [
	'PageType.Base.View',
	'PartLookup.Assemblies.List.View',
  // 'PartLookup.PartList.View',
	
  'partlookup_partlookup.tpl',
  
	'Utils',
	'underscore',
], function (
  PageTypeBaseView,
  PartLookupAssembliesListView,
  // PartLookupPartListView,
  
  partlookup_partlookup_tpl,
  
	Utils,
	_,
) {
	'use strict';

	return PageTypeBaseView.PageTypeBaseView.extend({
		template: partlookup_partlookup_tpl,

		getSelectedMenu: function () {
			return 'modelsearchlist';
		},

    getEvents: function() {
      return {
        'click .partlookup-diagrams-cell-item': 'clearHotspots',
        'click [data-view="AssembliesList.View"]': 'closeHotspotTooltip',
        'click [data-view="PartsList.View"]': 'closeHotspotTooltip',
      }
    },

    clearHotspots: function() {
      this.options.model.set('hotspots', []);
    },

    closeHotspotTooltip: function() {
      var $tooltip = $('.hotspot-tooltip');

      $tooltip.stop().animate({
        opacity: 0
      }, 200, function() {
        $tooltip.hide();
      });
    },

		beforeShowContent: function () {

      var self = this;
      this.model = this.options.model;
      
      var modelSearchInput = this.options.routerArguments[0];
      var selectedAssemblyId = this.options.routerArguments[1];

      var oldModelSearchInput = this.model.get('modelSearchInput');
      var oldSelectedAssemblyId = this.model.get('oldSelectedAssemblyId');

      if ( oldModelSearchInput !== modelSearchInput ) {
        this.model.set('modelSearchInput', modelSearchInput);
      }

      if ( oldSelectedAssemblyId !== selectedAssemblyId ) {
        this.model.set('selectedAssemblyId', selectedAssemblyId);
      }

      this.model.on('change:modelSearchInput', this.resetAssemblyParts, this);

			this.getBreadcrumbPages = function () {

        var displayedModelNumber = this.model.get('modelName') || modelSearchInput;
        var displayedBreadcrumb = this.model.get('brandData')?.brandName ?
          this.model.get('brandData').brandName + ' ' + displayedModelNumber :
          displayedModelNumber;

        var breadCrumbs = [{
          text: Utils.translate('Model Search: ' + displayedBreadcrumb),
          href: '/model-search/' + displayedModelNumber,
        }];

        if ( !!selectedAssemblyId ) {
          breadCrumbs.push({
            text: Utils.translate( selectedAssemblyId ),
          })
        }

        return breadCrumbs;
			};

			this.title = Utils.translate('Model Search');

      return this.model.fetch({
        method: 'GET',
        data: {
          modelSearchInput: self.model.get('modelSearchInput') || '',
          selectedAssemblyId: self.model.get('selectedAssemblyId') || '',
          modelName: self.model.get('modelName') || '' ,
          modelId: self.model.get('modelId') || '',
          brandCode: self.model.get('brandData')?.brandCode || '',
          brandName: self.model.get('brandData')?.brandName || '',
        }
      });
		},

    getChildViews: function() {

      return {
        'AssembliesList.View': function() {
  
          if ( !!this.options.model.get('modelSearchInput') ) {
            return new PartLookupAssembliesListView({
              model: this.options.model,
              application: this.options.application,
              searchComponent: this.options.searchComponent
            });
          }
        },
      }
    },

    resetAssemblyParts: function() {
      this.model.set('modelId', null);
      this.model.set('modelName', null);
      this.model.set('selectedAssemblyId', null);
      this.model.set('selectedAssembly', {});
      this.model.set('brandData', {});
    },

		getContext: function () {
			return {};
		},
	});
});
